import React, { Fragment } from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import styled from 'styled-components';
import Translate from '../../../helpers/Translate';
const OpitionDiv = styled.div`
  display: block;
  text-align: center;
`;

const ChatSuggestiionItems = ({ item, colors, isTranslate, translateLang }) => {
  const element1 = JSON.parse(item.text);
  return (
    <Fragment>
      <OpitionDiv>
        {element1.map((e) => {
          return (
            <div
              style={{
                padding: '5px',
                display: 'inline-block',
              }}
            >
              <div
                className="chat-options"
                style={{
                  backgroundColor: colors.suggestionBackground,
                  color: colors.suggestionText,
                  cursor: 'pointer',
                }}
              >
                <span> {isTranslate === true ? <Translate input={e.text} lang={translateLang}></Translate> :
                  e.text}</span>
              </div>
            </div>
          );
        })}
      </OpitionDiv>
    </Fragment>
  );
};

export default ChatSuggestiionItems;
